// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"62439042","455":"c26f4292","977":"9a6f4662"}[chunkId] + ".chunk.js";
};